module.exports = __webpack_public_path__ + "static/img/zoom_btn2.e2fcbeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/zoom_btn2.png
// module id = ro35
// module chunks = 4